export const SCHEMA_ORG_URL = 'https://schema.org';

export const ItemAvailability = {
  PRE_ORDER: `${SCHEMA_ORG_URL}/PreOrder`,
  OUT_OF_STOCK: `${SCHEMA_ORG_URL}/OutOfStock`,
  IN_STOCK: `${SCHEMA_ORG_URL}/InStock`,
};
